var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-create-eval__publish" },
    [
      _c("eval-notify", {
        ref: "evalNotify",
        attrs: { id: _vm.id, noTiming: _vm.noTiming },
        on: { "get-info": _vm.getInfo },
      }),
      _c("yxtbiz-eval-step-footer", {
        attrs: { operation: _vm.operation, "footer-width": "960px" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }